document.addEventListener('DOMContentLoaded', function() {
   // Fix: Check for the correct class name
   if (document.querySelector('.skil-findadealer-sc')) {
      console.log('Found service center section');
      const serviceCenterTableBody = document.querySelector('#skil-findadealer-sc-table tbody');

      if (!serviceCenterTableBody) {
         console.error('Table body not found!');
         return;
      }
      console.log('Table body found:', serviceCenterTableBody);

      // Pagination variables
      let allData = [];
      let filteredData = [];
      let currentPage = 1;
      const itemsPerPage = 20;

      // Improved CSV to objects parser that handles quoted fields
      function csvToObjects(csvText) {
         const lines = csvText.split('\n').filter(line => line.trim());
         if (lines.length === 0) return [];

         // Parse CSV line considering quoted fields
         function parseCSVLine(line) {
            const result = [];
            let current = '';
            let inQuotes = false;

            for (let i = 0; i < line.length; i++) {
               const char = line[i];
               const nextChar = line[i + 1];

               if (char === '"') {
                  if (inQuotes && nextChar === '"') {
                     current += '"';
                     i++; // Skip next quote
                  } else {
                     inQuotes = !inQuotes;
                  }
               } else if (char === ',' && !inQuotes) {
                  result.push(current.trim());
                  current = '';
               } else {
                  current += char;
               }
            }
            result.push(current.trim());
            return result;
         }

         const headers = parseCSVLine(lines[0]);
         console.log('CSV Headers:', headers);

         const objects = [];
         for (let i = 1; i < lines.length; i++) {
            if (lines[i].trim()) {
               const values = parseCSVLine(lines[i]);
               const obj = {};
               headers.forEach((header, index) => {
                  obj[header] = values[index] || '';
               });
               objects.push(obj);
            }
         }
         console.log('Parsed CSV objects:', objects.length, 'rows');
         if (objects.length > 0) {
            console.log('First row sample:', objects[0]);
         }
         return objects;
      }

      // Render table rows for current page
      function renderTableRows() {
         serviceCenterTableBody.innerHTML = '';

         const startIndex = (currentPage - 1) * itemsPerPage;
         const endIndex = startIndex + itemsPerPage;
         const pageData = filteredData.slice(startIndex, endIndex);

         pageData.forEach((obj, index) => {
            const row = document.createElement('tr');
            row.innerHTML = `
                    <td class="p-main">${obj['partner_type'] || ''}</td>
                    <td class="p-main">${obj['ship_to_name'] || ''}</td>
                    <td class="p-main">${obj['shipping_address'] || ''}</td>
                    <td class="p-main">${obj['shipping_city'] || ''}</td>
                    <td class="p-main">${(obj['shipping_state'] || '').toUpperCase()}</td>
                    <td class="p-main">${obj['shipping_zip'] || ''}</td>
                    <td class="p-main">
                       ${obj['phone']
                        ? (() => {
                           const digits = obj['phone'].replace(/\D/g, ""); // keep only numbers
                           if (digits.length === 10) {
                              const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                              return `<a href="tel:${digits}">${formatted}</a>`;
                           }
                           return ""; // ignore if not 10 digits
                        })()
                        : ""}
                     </td>
                `;
            serviceCenterTableBody.appendChild(row);
         });

         updatePaginationControls();
      }

      // Update pagination controls
      function updatePaginationControls() {
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         const paginationControls = document.getElementById('pagination-controls');
         const prevBtn = document.getElementById('prev-btn');
         const nextBtn = document.getElementById('next-btn');
         const paginationNumbers = document.getElementById('pagination-numbers');
         const startEntry = document.getElementById('start-entry');
         const endEntry = document.getElementById('end-entry');
         const totalEntries = document.getElementById('total-entries');

         // Show/hide pagination based on data
         if (filteredData.length > itemsPerPage) {
            paginationControls.style.display = 'flex';
         } else {
            paginationControls.style.display = 'none';
            return;
         }

         // Update info text
         const startIndex = (currentPage - 1) * itemsPerPage + 1;
         const endIndex = Math.min(currentPage * itemsPerPage, filteredData.length);
         startEntry.textContent = startIndex;
         endEntry.textContent = endIndex;
         totalEntries.textContent = filteredData.length;

         // Update prev/next buttons
         prevBtn.disabled = currentPage === 1;
         nextBtn.disabled = currentPage === totalPages;

         // Update page numbers
         paginationNumbers.innerHTML = '';

         const maxVisiblePages = 5;
         let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
         let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

         // Adjust start if we're near the end
         if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
         }

         // Add first page and ellipsis if needed
         if (startPage > 1) {
            addPageNumber(1);
            if (startPage > 2) {
               const ellipsis = document.createElement('span');
               ellipsis.textContent = '...';
               ellipsis.className = 'pagination-ellipsis';
               paginationNumbers.appendChild(ellipsis);
            }
         }

         // Add visible page numbers
         for (let i = startPage; i <= endPage; i++) {
            addPageNumber(i);
         }

         // Add last page and ellipsis if needed
         if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
               const ellipsis = document.createElement('span');
               ellipsis.textContent = '...';
               ellipsis.className = 'pagination-ellipsis';
               paginationNumbers.appendChild(ellipsis);
            }
            addPageNumber(totalPages);
         }
      }

      // Add page number button
      function addPageNumber(pageNum) {
         const pageButton = document.createElement('button');
         pageButton.textContent = pageNum;
         pageButton.className = 'pagination-number';
         if (pageNum === currentPage) {
            pageButton.classList.add('active');
         }
         pageButton.addEventListener('click', () => {
            currentPage = pageNum;
            renderTableRows();
         });
         document.getElementById('pagination-numbers').appendChild(pageButton);
      }

      // Filter data based on state
      function filterData(selectedState) {
         if (selectedState === 'ALL LOCATIONS') {
            filteredData = [...allData];
         } else {
            filteredData = allData.filter(obj => {
               const state = (obj['shipping_state'] || '').toUpperCase();
               return state === selectedState.toUpperCase();
            });
         }
         currentPage = 1; // Reset to first page when filtering
         renderTableRows();
      }

      // Check if CSV URL is available
      console.log('CSV URL:', findADealerCSV);

      if (!findADealerCSV) {
         console.error('No CSV URL found. Make sure findADealerCSV is set.');
         return;
      }

      // Fetch CSV data
      fetch(findADealerCSV)
         .then(response => {
            console.log('CSV fetch response:', response.status);
            if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
         })
         .then(csvData => {
            console.log('CSV data length:', csvData.length);
            console.log('CSV data first 200 chars:', csvData.substring(0, 200));
            const data = csvToObjects(csvData);

            if (data.length === 0) {
               console.warn('No data found in CSV');
               return;
            }

            data.sort((a, b) => {
               const zipA = (a.shipping_state || '').padStart(10, '0');
               const zipB = (b.shipping_state || '').padStart(10, '0');
               return zipA.localeCompare(zipB);
            });

            allData = data;
            filteredData = [...data];
            renderTableRows();

            console.log('Added', data.length, 'rows to table with pagination');
         })
         .catch(error => {
            console.error('Error fetching CSV data:', error);
         });

      // Set up the select filter
      const serviceSelect = document.getElementById('js-service-center');

      if (!serviceSelect) {
         console.error('Service center select element not found');
         return;
      }

      $(".js-selectmenu").on('selectmenuchange', function () {
         filterData(this.value);
      });

      // Set up pagination button events
      document.getElementById('prev-btn').addEventListener('click', () => {
         if (currentPage > 1) {
            currentPage--;
            renderTableRows();
         }
      });

      document.getElementById('next-btn').addEventListener('click', () => {
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         if (currentPage < totalPages) {
            currentPage++;
            renderTableRows();
         }
      });

   } else {
      console.log('Service center section not found on this page');
   }
});